<span class="inapp-bell-host">
  <button
    mat-icon-button
    [matMenuTriggerFor]="notificationmenu"
    (menuOpened)="onMenuOpened()"
    (menuClosed)="onMenuClosed()"
    [attr.aria-label]="ariaLabel"
    class="d-flex align-items-center justify-content-center"
  >
    @if (isTaskBell) {
      <i class="iconify icon-20 d-flex" data-icon="solar:checklist-minimalistic-line-duotone"></i>
    } @else {
      <i class="iconify icon-20 d-flex" data-icon="solar:bell-line-duotone"></i>
    }
  </button>
  @if (unread > 0) {
    <span class="inapp-bell-badge" [class.inapp-bell-badge--task]="isTaskBell">
      {{ unread > 99 ? '99+' : unread }}
    </span>
  }
</span>

<mat-menu
  #notificationmenu="matMenu"
  xPosition="before"
  class="topbar-dd cardWithShadow inapp-bell-menu-panel"
>
<div class="d-flex align-items-center p-x-32 p-y-16">
    <h6 class="f-s-16 f-w-600 m-0">{{ menuTitle }}</h6>
    @if (unread > 0) {
      <span class="m-l-auto">
        <span
          class="p-x-8 p-y-4 f-w-500 rounded f-s-12 text-white"
          [class.bg-primary]="!isTaskBell"
          [class.bg-warning]="isTaskBell"
        >
          {{ unreadBadgeText }}
        </span>
      </span>
    }
</div>

<div class="inapp-bell-scroll">
    @if (items.length === 0) {
<div class="p-x-32 p-y-24 text-muted f-s-13 text-center">
      {{ emptyLabel }}
</div>
    }
    @for (row of items; track row.id) {
      <div
        mat-menu-item
        class="p-x-30 p-y-12 inapp-bell-item inapp-bell-item-row"
        [class.inapp-bell-item--read]="!isTaskBell && rowNotificationRead(row)"
        [class.inapp-bell-item--unread]="!isTaskBell && !rowNotificationRead(row)"
        [class.inapp-bell-item--pending]="isTaskBell && rowPendingTask(row)"
        [class.inapp-bell-item--done]="isTaskBell && !rowPendingTask(row)"
      >
        <div class="inapp-bell-item-layout">
          <button
            type="button"
            class="inapp-bell-row-body"
            [class.inapp-bell-row-body--clickable]="!!row.link"
            (click)="open(row)"
          >
            <span
              class="inapp-bell-row-icon flex-shrink-0 rounded-circle icon-48 d-flex align-items-center justify-content-center"
              [ngClass]="rowIconClasses(row)"
            >
              <i-tabler [name]="rowTablerIcon(row)" class="icon-20 d-flex"></i-tabler>
            </span>
            <div class="inapp-bell-row-content">
              <h5
                class="f-s-14 f-w-600 m-0 inapp-bell-title"
                [class.text-primary]="!isTaskBell && !rowNotificationRead(row)"
                [class.text-warning]="isTaskBell && rowPendingTask(row)"
                [class.text-success]="isTaskBell && !rowPendingTask(row)"
              >
                {{ row.title }}
              </h5>
              <span class="inapp-bell-date f-s-12 text-muted">{{ formatWhen(row.created_at) }}</span>
              @if (row.message) {
                <span class="d-block f-s-12 text-muted inapp-bell-message">{{ row.message }}</span>
              }
              @if (!isTaskBell && !rowNotificationRead(row)) {
                <span class="d-block f-s-12 text-primary f-w-500 m-t-4">New</span>
              }
              @if (isTaskBell && rowPendingTask(row)) {
                <span class="d-block f-s-12 text-warning f-w-500 m-t-4">Action required</span>
              }
              @if (isTaskBell && !rowPendingTask(row)) {
                <span class="d-block f-s-12 text-success f-w-500 m-t-4">Done</span>
              }
            </div>
          </button>
      
        </div>
      </div>
    }
</div>

</mat-menu>
